
import {Component} from './base';
// @ts-ignore
import Tour from 'bootstrap-tour';

export class TourComponent extends Component {
  public static shouldLoad() {
    return $('.tour-button').length > 0;
  }

  public load() {
    const self = this;
    $('.tour-button').click(function() {
      const name = $(this).data('tour') as string;
      self.startTour(name);
    });
  }

  private startTour(tourName: string) {
    // todo
  }
}



// WEBPACK FOOTER //
// ./~/source-map-loader!./app/Resources/assets/js/components/tour.ts